var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoardCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "458062CC-4B95-4632-8106-DC44F0B703D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.2-Tasks---Edit-Task---Employee",
    transform: "translate(-603.000000, -745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "board-copy",
    transform: "translate(603.000000, 743.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8765957,0 L1.0893617,0 C0.487723847,0 0,0.487723847 0,1.0893617 L0,22.8765957 C0,23.4782336 0.487723847,23.9659574 1.0893617,23.9659574 L22.8765957,23.9659574 C23.4782336,23.9659574 23.9659574,23.4782336 23.9659574,22.8765957 L23.9659574,1.0893617 C23.9659574,0.487723847 23.4782336,0 22.8765957,0 Z M21.787234,21.787234 L2.1787234,21.787234 L2.1787234,2.1787234 L21.787234,2.1787234 L21.787234,21.787234 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53617021,18.5191489 C7.13780807,18.5191489 7.62553191,18.0314251 7.62553191,17.4297872 L7.62553191,9.80425532 C7.62553191,9.20261746 7.13780807,8.71489362 6.53617021,8.71489362 C5.93453236,8.71489362 5.44680851,9.20261746 5.44680851,9.80425532 L5.44680851,17.4297872 C5.44680851,18.0314251 5.93453236,18.5191489 6.53617021,18.5191489 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9829787,18.5191489 C12.5846166,18.5191489 13.0723404,18.0314251 13.0723404,17.4297872 L13.0723404,6.53617021 C13.0723404,5.93453236 12.5846166,5.44680851 11.9829787,5.44680851 C11.3813409,5.44680851 10.893617,5.93453236 10.893617,6.53617021 L10.893617,17.4297872 C10.893617,18.0314251 11.3813409,18.5191489 11.9829787,18.5191489 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4297872,18.5191489 C18.0314251,18.5191489 18.5191489,18.0314251 18.5191489,17.4297872 L18.5191489,9.80425532 C18.5191489,9.20261746 18.0314251,8.71489362 17.4297872,8.71489362 C16.8281494,8.71489362 16.3404255,9.20261746 16.3404255,9.80425532 L16.3404255,17.4297872 C16.3404255,18.0314251 16.8281494,18.5191489 17.4297872,18.5191489 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoardCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boardCopy.1008825b464b4e369f649a02b3a2ca4a.svg";